import React from 'react';
import { Redirect } from 'react-router-dom';

export function PageError(): React.JSX.Element {
  return (
    <div>
      <Redirect to={'/noProfileDefined'} />
    </div>
  );
}
